import React, { Fragment, useContext } from "react";
import { Store } from "../../state/state";
import ColorPickerUI from "../../common/ColorPickerUI";
import Title from "../../common/Title";
import SwitchButton from "../../common/SwitchButton";
import { useObserver } from "mobx-react";
import MenuItem, { MenuTexture } from "../../common/Menu";
import TextField from "../../common/TextField";
import ThemePicker from "../../common/ThemePicker";

function SettingDefault() {
  const store = useContext(Store);
  return useObserver(() => (
    <Fragment>
      <Title>القوالب</Title>
      <ThemePicker />

      <Title>الوان ايام الشهر</Title>

      <ColorPickerUI
        id="days-active"
        label={"ايام الشهر"}
        color={store.theme.main.blockActive.backgroundColor}
        onChange={(color) => store.setMainColor("blockActive", color.hex)}
      />
      <ColorPickerUI
        id="border-days"
        label={"حدود الشهر"}
        color={store.theme.main.blockActive.borderColor}
        onChange={(color) =>
          (store.theme.main.blockActive.borderColor = color.hex)
        }
      />
      <ColorPickerUI
        id="days-empty"
        label={"الفراغ"}
        color={store.theme.main.blockUnActive.backgroundColor}
        onChange={(color) => store.setMainColor("blockUnActive", color.hex)}
      />

      <Title>آخرى</Title>
      <SwitchButton
        value={store.theme.main.withBorderDays}
        label={"حذف مربع التتبع للأيام الشهر"}
        onChange={(value) => (store.theme.main.withBorderDays = value)}
      />
    </Fragment>
  ));
}

export default SettingDefault;
